import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

const Portal = ({ children, node }) => {
    const [defaultNode] = useState(node || document.createElement('div'));
    useEffect(() => {
        document.body.appendChild(defaultNode);
        return () => {
            document.body.removeChild(defaultNode);
        };
    }, [defaultNode]);
    if (typeof window === 'undefined') {
        return null;
    }
    return ReactDOM.createPortal(children, defaultNode);
};

export { Portal };
//# sourceMappingURL=Portal.js.map
